import {Component} from '@angular/core';
import {AbstractTopicModalComponent} from '../abstract-topic-modal/abstract-topic-modal.component';

/**
 * Class for the PrimaryTopicModalComponent
 * @class PrimaryTopicModalComponent
 *
 * @description Implementation for the PrimaryTopicModalComponent. Defines multiple as false to use radio inputs
 *
 * @usage
 * To be used with a [ModalController]{@link https://ionicframework.com/docs/api/components/modal/ModalController/} create call
 * ```ts
 *
 * const modal = this.modalController.create(
 *    PrimaryTopicModalComponent,
 *    { choices: this.choices, value: this.value }:
 *    {
 *      choices: TreeNode[],
 *      value: TreeNode[]
 *    },
 *    {}: ModalOptions);
 * modal.onDidDismiss((data) => this.hModalDismiss(data))
 * modal.present();
 * ```
 */
@Component({
  selector: 'advtech-primary-topic-modal',
  templateUrl: '../abstract-topic-modal/abstract-topic-modal.component.html',
})
export class PrimaryTopicModalComponent extends AbstractTopicModalComponent {
  /**
   * Label for the modal
   * @type {string}
   */
  title: string = 'Primary Topic';

  /**
   * Tells the modal to use radio inputs
   * @type {boolean}
   */
  multiple: boolean = false;
}


// WEBPACK FOOTER //
// ./src/app/shared/components/metadata-menu/topic/primary-topic-modal/primary-topic-modal.component.ts